// pages/public/components/SearchBar.jsx
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useDebouncedValue } from "../../../../hooks/useDebounce";

const SearchBar = ({
  onSearch,
  searchText,
  setSearchText,
  placeholder = "Tìm kiếm",
}) => {
  const inputRef = useRef(null);
  const [inner, setInner] = useState(searchText ?? "");
  const debounced = useDebouncedValue(inner, 300);

  // đồng bộ ra ngoài khi debounce xong
  useEffect(() => {
    setSearchText?.(debounced);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  // gọi onSearch khi nhấn Enter
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const searchValue = inner.trim();
      setSearchText?.(searchValue);
      onSearch?.(searchValue, {
        immediate: true,
        search_value: searchValue,
      });
    }
  };

  const clearSearch = () => {
    setInner("");
    setSearchText?.("");
    inputRef.current?.focus();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="flex h-[42px] w-full items-center justify-between"
    >
      <div className="flex w-full gap-4">
        <div className="relative flex w-full items-center pr-2.5">
          <input
            ref={inputRef}
            type="text"
            placeholder={placeholder}
            className="
              w-full rounded-lg border border-gray-200 px-4 py-2
              focus:border-[#0457C2] focus:outline-none focus:ring-2 focus:ring-[#0457C2]/20
            "
            value={inner}
            autoComplete="off"
            onChange={(e) => setInner(e.target.value)}
            onKeyDown={handleKeyDown}
            aria-label="Ô tìm kiếm"
          />

          {/* Nút Clear */}
          {!!inner && (
            <button
              type="button"
              onClick={clearSearch}
              className="absolute right-10 text-gray-400 hover:text-gray-600 focus:outline-none"
              aria-label="Xoá từ khóa"
              title="Xoá"
            >
              ×
            </button>
          )}

          {/* Nút search click */}
          <button
            type="button"
            className="absolute right-3 cursor-pointer rounded-md p-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#0457C2]/40"
            onClick={() => onSearch?.()}
            aria-label="Tìm kiếm"
            title="Tìm kiếm"
          >
            <img src="/icons/search-black.svg" alt="" className="h-5 w-5" />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default SearchBar;
